import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

export default function BookingCard() {
  const fields = [
    { id: "bookingNumber", label: "Booking Number" },
    { id: "clientName", label: "Client Name" },
    { id: "pickuploc", label: "Pickup Location" },
    { id: "returnloc", label: "Return Location" },
    { id: "startdate", label: "Start Date" },
    { id: "endDate", label: "End Date" },
    { id: "companyName", label: "Company Name" },
    { id: "vehicle", label: "Vehicle" },
    { id: "totalAmount", label: "Total Amount" },
  ];
  return (
    <Grid container spacing={2}>
      {fields.map((e) => (
        <Grid item xs={12} sm={4} key={e.id}>
          <TextField id={e.id} label={e.label} required fullWidth></TextField>
        </Grid>
      ))}
    </Grid>
  );
}
